export default __webpack_public_path__ + "static/media/T_wdt_c_cap_1.aeabe041.mp3";